import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ user, children, requiredRole }) => {
    const location = useLocation();
    if (!user) {
        // Po zalogowaniu wracamy na stronę, którą ktoś próbował otworzyć
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (requiredRole) {
        const hasRole = user.roles && Array.isArray(user.roles) && user.roles.includes(requiredRole);
        if (!hasRole) {
            return <Navigate to="/" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;